export const mostrarError = (err: any) => {
  if (err?.status) {
    if (err.status === 401) return { action: 'LOGOUT' };
    const mensaje = err.error?.message || err.error || `Error del servidor: ${err.status}`;
    return { action: 'TOAST', message: mensaje }
  }
  if (err instanceof Error) return { action: 'TOAST', message: err.message };
  if (typeof err === 'string') return { action: 'TOAST', message: err };
  const fallback = JSON.stringify(err, Object.getOwnPropertyNames(err));
  return { action: 'TOAST', message: `ERROR: ${fallback}` }
}

export const handleUrl = (url: string): string => {
  const uri = new URL(url);
  return uri.pathname.slice(1)
}

export const checkVer = (version: string, VERSION: string): boolean => {
  if (!version || !VERSION) return false;
  const matrix: string[] = VERSION.split('.');
  const versionActual: string = `${matrix[0]}.${matrix[1]}.${matrix[2]}`;
  return versionActual !== version
}

const getMimeType = (filename: string) => {
  if (filename.toLowerCase().endsWith('.pdf')) return 'application/pdf';
  if (filename.toLowerCase().match(/\.(jpg|jpeg)$/i)) return 'image/jpeg';
  if (filename.toLowerCase().endsWith('.png')) return 'image/png';
  if (filename.toLowerCase().endsWith('.webp')) return 'image/webp';
  return 'application/octet-stream';
}

export const getFileInfo = (url: string, blob: Blob) => {
  let cleanName = url.split('/').pop() || `doc-babycloud-${Date.now()}`;
  cleanName = cleanName.split('?')[0];
  let mimeType = getMimeType(cleanName);
  if (blob.type && blob.type !== mimeType && blob.type !== 'application/octet-stream') {
    mimeType = blob.type
  }
  if (mimeType === 'application/pdf' && !cleanName.toLowerCase().endsWith('.pdf')) {
    cleanName += '.pdf';
  } else if (mimeType.startsWith('image/') && !cleanName.includes('.')) {
    if (mimeType.includes('png')) cleanName += '.png';
    else if (mimeType.includes('webp')) cleanName += '.webp';
    else cleanName += '.jpg'
  }
  return {cleanName, mimeType}
}

export const isNumber = (n: any): boolean => !isNaN(parseFloat(n)) && isFinite(n);

export const isInt = (n: any): boolean => n % 1 === 0;

export const isNatural = (n: any): boolean => isInt(n) && n >= 0;

export const fileToBase64 = (file: File): Promise<string> => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result.toString());
  reader.onerror = error => reject(error);
})

export const base64ToFile = async (data64: string, filename: string): Promise<File> => {
  try {
    const res = await fetch(data64);
    const blob = await res.blob();
    return new File([blob], filename, {type: blob.type})
  } catch {
    throw new Error('ERROR EN EL PROCESO DE ARCHIVO')
  }
}

export const urlToBase64 = (url: string): Promise<string> => new Promise((resolve, reject) => {
  const img = new Image();
  img.crossOrigin = 'Anonymous';
  img.src = url;
  img.onload = () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.height = img.height;
    canvas.width = img.width;
    ctx.drawImage(img, 0, 0);
    resolve(canvas.toDataURL('image/jpeg'))
  };
  img.onerror = error => reject(error)
});

export const resizeImg = async (srcBase64: string, maxWidth: number, maxHeight: number): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = srcBase64;
    img.onerror = error => reject(error);
    img.onload = () => {
      const width: number = img.width;
      const height: number = img.height;
      const canvas: HTMLCanvasElement = document.createElement('canvas');
      const ctx: CanvasRenderingContext2D = canvas.getContext('2d');
      if (!ctx) {
        return reject(new Error('No se pudo obtener el contexto del canvas'))
      }
      let newWidth: number;
      let newHeight: number;
      if (width <= maxWidth && height <= maxHeight) {
        newWidth = width;
        newHeight = height;
      } else {
        const ratio: number = Math.min(maxWidth / width, maxHeight / height);
        newWidth = width * ratio;
        newHeight = height * ratio;
      }
      canvas.width = newWidth;
      canvas.height = newHeight;
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      resolve(canvas.toDataURL('image/jpeg', 0.9))
    }
  })
}

export const quitarAcentos = (value: string): string => value
  .replace(/á/g, 'a')
  .replace(/é/g, 'e')
  .replace(/í/g, 'i')
  .replace(/ó/g, 'o')
  .replace(/ú/g, 'u');

export const getRndInt = (min: number, max: number): number => Math.floor(Math.random() * (max - min + 1)) + min;